<template>
  <div v-if="recom">
    <p class="has-text-grid-1 has-text-weight-bold is-size-14px pb-10">
      {{$t('recapEnseigne.societe')}}
    </p>
    <div class="card pa-10 mb-10">
      {{ getLibelleSociete }}
    </div>
    <p class="has-text-grid-1 has-text-weight-bold is-size-14px pb-10">
      {{$t('recapEnseigne.titre')}}
    </p>
    <a ref="lienDownload"></a>

    <div class="card mb-10" :class="{'mb-20': !recom.assistantId}">
      <header class="card-header">
        <div class="card-header-title is-paddingless">
          <article class="media media-align-center">
            <figure class="media-left">
              <p class="image is-58x58">
                <img :src="func.getImg(pointDeVenteEnCours.srcImg)">
              </p>
            </figure>
            <div class="media-content">
              <div class="content">
                <p class="is-size-14px has-text-weight-bold has-text-gird-1 mb-0">
                  {{pointDeVenteEnCours.nomCommercial}}
                </p>
                <p class="is-size-7 has-text-default">
                  {{ adresseLibelle }}
                </p>
              </div>
            </div>
          </article>
        </div>
      </header>
    </div>
    <recom-label
      :recommandation="recom"
      isDetail showLabel>
    </recom-label>
    <p class="has-text-grid-1 has-text-weight-bold is-size-14px pb-10"
    v-if="recom.assistantId">
      {{$t('recapEnseigne.assistant')}}
    </p>
    <div class="card pa-10 mb-20" v-if="recom.assistantId">
      {{ getAssistantLibelle }}
    </div>

    <button
      class="button is-primary is-fullwidth has-text-weight-bold mb-20"
      @click="$emit('change-send', !isSend)">
      <b-icon icon="email" class="mr-10"></b-icon>
      <span>{{$t('recapEnseigne.libelleBtnEnvoyerParEmail')}}</span>
    </button>
    <b-button
      type="is-info"
      class="is-fullwidth has-text-weight-bold mb-20"
      :disabled="!societeActiveId || recom.etat === constantes.ETAT_BROUILLON"
      @click="openModalDevisAchat"
    >
      <span class="ml-2">
      {{ $t('listeDevisAchat.voirDevisAchat') }}
      </span>
    </b-button>

    <p class="has-text-grid-1 has-text-weight-bold is-size-14px pb-10">
      {{$t('recapEnseigne.titreRecomDematerialisee')}}
    </p>
    <button
      tag="input"
      class="button is-primary is-fullwidth has-text-weight-bold mb-10"
      @click="openLink(recom.portailAnnonceurLink)">
      <b-icon icon="link-variant" class="mr-10"></b-icon>
      <span>{{$t('recapEnseigne.libelleBtnOuvrir')}}</span>
    </button>
    <button
      tag="input"
      class="button is-primary is-fullwidth has-text-weight-bold mb-10"
      @click="copyLink(recom.portailAnnonceurLink)">
      <b-icon icon="link-variant" class="mr-10"></b-icon>
      <span>{{$t('recapEnseigne.libelleBtnCopierLien')}}</span>
    </button>
    <p class="is-size-7 has-text-default mb-20">
      {{$t('recapEnseigne.textRecomDematerialisee')}}
    </p>

    <p class="has-text-grid-1 has-text-weight-bold is-size-14px pb-10">
      {{$t('recapEnseigne.titreDocTelecharger')}}
    </p>
    <button
      class="button is-primary is-fullwidth has-text-weight-bold mb-10"
      :class="{
        'is-loading': loadingFichierRecomPdf
      }"
      @click="getPdf">
      <b-icon icon="file-pdf" class="mr-10"></b-icon>
      <span>{{$t('recapEnseigne.libelleBtnRecommandation')}}</span>
    </button>
    <button
      class="button is-primary is-fullwidth has-text-weight-bold mb-10"
      :class="{
        'is-loading': loadingFichierRecapBudgPdf
      }"
      @click="getRecapPdf">
      <b-icon icon="file-pdf" class="mr-10"></b-icon>
      <span>{{$t('recapEnseigne.libelleBtnRecpBudgetairePDF')}}</span>
    </button>
    <button
      class="button is-primary is-fullwidth has-text-weight-bold mb-20"
      :class="{
        'is-loading': loadingFichierRecapExcel
      }"
      @click="getRecapExcel">
      <b-icon icon="file-excel" class="mr-10"></b-icon>
      <span>{{$t('recapEnseigne.libelleBtnRecpBudgetaireExcel')}}</span>
    </button>
    <b-modal
      v-model="isModalDevisAchatOpen"
      :width="1440"
      trap-focus
      aria-role="dialog"
      aria-modal>
      <modal-liste-devis-achat
        v-if="isModalDevisAchatOpen"
        :reference-externe="recom ? recom.id : null"
        :societe-id="(recom && recom.societeId) || societeActiveId"
        @close="isModalDevisAchatOpen = false"/>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import { getImg, adressFullStringGetter } from '@/services/general/general';
import gestionErreur from '@/services/general/gestionErreur';
import RecomLabel from '@/components/recommandation/recomLabel';
import { exportRecapPdf, exportPdf, exportExcel } from '@/api/recommandation';
import ModalListeDevisAchat from '@/views/recommandations/ModalListeDevisAchat.vue';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';
import { ETAT_BROUILLON } from '@/configuration/devisConf';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametrage');

export default {
  props: {
    societe: Object,
    recom: Object,
    pointDeVente: {
      type: Object,
      default: null,
    },
    isSend: Boolean,
  },
  components: {
    ModalListeDevisAchat,
    RecomLabel,
  },
  data() {
    return {
      pJointes: [],
      func: { getImg },
      loadingFichierRecomPdf: false,
      loadingFichierRecapBudgPdf: false,
      loadingFichierRecapExcel: false,
      isModalDevisAchatOpen: false,
      constantes: { ETAT_BROUILLON },
    };
  },
  computed: {
    ...Societe.mapGetters({
      societes: 'societes',
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    users() {
      return this.parametre(PARAMETRES_KEYS.utilisateur);
    },
    pointDeVenteEnCours() {
      return this.pointDeVente;
    },
    adresseLibelle() {
      if (!this.pointDeVente || !this.pointDeVente.adressePostale) return '';
      return adressFullStringGetter(this.pointDeVente.adressePostale);
    },
    dateCreation() {
      const date = this.recom.creationTime;
      return moment(date).format('DDMMYYYY');
    },
    fileName() {
      if (this.pointDeVenteEnCours.nomCommercial && this.dateCreation) {
        return [
          this.pointDeVenteEnCours.nomCommercial, '_RECAPBUDGETAIRE_',
          this.dateCreation, '.xlsx',
        ].join('');
      }
      return '';
    },
    getLibelleSociete() {
      return this.societe ? this.societe.libelle : '';
    },
    getAssistantLibelle() {
      if (!this.recom.assistantId) return '';
      const result =  this.users.find(u => u.id === this.recom.assistantId);
      return result? result.nom + ' ' + result.prenom : '';
    },
  },
  methods: {
    async getPdf() {
      this.loadingFichierRecomPdf = true
      try {
        const result = await exportPdf(this.recom.id);
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(result.data);
        const disposition = result.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (error) {
        gestionErreur(`Erreur lors de l'export PDF de la recommandation id: ${this.recom.id}`, error);
      } finally {
        this.loadingFichierRecomPdf = false;
      }
    },
    async getRecapPdf() {
      this.loadingFichierRecapBudgPdf = true
      try {
        const result = await exportRecapPdf(this.recom.id);
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(result.data);
        const disposition = result.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (error) {
        gestionErreur(`Erreur lors de l'export du récapitulatif budgétaire PDF de la recommandation id: ${this.recom.id}`, error);
      } finally {
        this.loadingFichierRecapBudgPdf = false;
      }
    },
    async getRecapExcel() {
      this.loadingFichierRecapExcel = true
      try {
        const result = await exportExcel(this.recom.id);
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(result.data);
        const disposition = result.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (error) {
        gestionErreur(`Erreur lors de l'export PDF de la recommandation id: ${this.recom.id}`, error);
      } finally {
        this.loadingFichierRecapExcel = false;
      }
    },
    openModalDevisAchat() { 
      this.isModalDevisAchatOpen = true;
    },
    copyLink(lien) {
      const domCreate = document.createElement('input');
      document.body.appendChild(domCreate);
      domCreate.setAttribute('value', lien);
      domCreate.select();
      try {
        const isCopied = document.execCommand('copy');
        if (isCopied) this.$buefy.toast.open({
                    message: this.$t('general.msgLienCopie'),
                    type: 'is-success'});
        else this.$buefy.toast.open({
                    message: this.$t('general.msgLienNonCopie'),
                    type: 'is-danger'});
      } catch (e) {
        this.$buefy.toast.open({
                    message: this.$t('general.msgLienNonCopie'),
                    type: 'is-danger'});
      }
    },
    openLink(lien){
      window.open(lien);
    },
  }
}
</script>
